import { Component } from 'react';
import {actions, Form} from 'forms/rrf';
import {Col, Container, Row} from 'react-bootstrap';
import {connect} from 'react-redux';
import {getQuestions} from '../../actions/about-you';
import {updateSecurityQuestions} from '../../actions/update-security-questions';
import ArrowButton from '../common/button-arrow';
import PageTitle from '../common/page-title/index';
import RequiredPasswordMaskInput from '../common/form/elements/required-password-mask-input';
import SecurityQuestionAnswer from '../common/form/user/security-question-answer-input';

import './update-security-questions.css';
import {USER_TYPE_REP} from '../../data/userTypes';

class UpdateSecurityQuestions extends Component {
  state = {};
  updateErrors = (field, value) => {
    this.setState({[field]: value});
  };
  onSaveClicked = (payload) => {
    const {area, dispatch} = this.props;
    const redirectUrl = area === USER_TYPE_REP ? '/team/my-profile' : '/my-profile';
    dispatch(actions.submitFields('deep.updateSecQ.user', updateSecurityQuestions(redirectUrl, payload)));
  };

  UNSAFE_componentWillMount() {
    this.props.dispatch(getQuestions());
  }

  render() {
    return (
      <Form
        model="deep.updateSecQ.user"
        onSubmit={payload => this.onSaveClicked(payload)}
      >
        <Container className="update-security-questions">
          <Row>
            <PageTitle>
              Update security questions
            </PageTitle>
          </Row>
          <Row>
            <RequiredPasswordMaskInput
              controlId="currentPassword"
              label="Current Password"
              model=".current_password"
              autoComplete="new-password"
            />

            <SecurityQuestionAnswer
              answerControlId="userSecurityAnswer1"
              answerModel=".security_answers_attributes[0].answer"
              questionControlId="userSecurityQuestion1"
              questionModel=".security_answers_attributes[0].security_question_id"
              questions={this.props.questions.filter(question => question.attributes['list-number'] === 1)}
            />

            <SecurityQuestionAnswer
              answerControlId="userSecurityAnswer2"
              answerLabel="Security answer 2"
              answerModel=".security_answers_attributes[1].answer"
              answerPlaceHolder="Security answer 2"
              questionControlId="userSecurityQuestion2"
              questionLabel="Security question 2"
              questionModel=".security_answers_attributes[1].security_question_id"
              questions={this.props.questions.filter(question => question.attributes['list-number'] === 2)}
            />
          </Row>
          <Row>
            <Col lg={12}>
              <ArrowButton
                arrow={false}
                className="float-end"
                color="red"
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Container>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  questions: state.aboutYou.questions,
  user: state.viewConfig.profile,
});

export default connect(mapStateToProps)(UpdateSecurityQuestions);
